import React, { Component } from "react";
import SpecialColumnList from "../../view/components/specialColumn/SpecialColumnList";
import {
  getSpecialColumnList,
  getEditId,
  getStoreData,
  getSpecialColumnListID,
  deleteSpecialColumnListID,
  getAddColumn,
  getColumnList,
  // clickUpLoad
} from "../../actions/convergenceMedia";
import * as utils from "../../utils/index";
import AddSpecialColumn from "../components/specialColumn/AddSpecialColumn";
import "antd/dist/antd.css";
import { HEADER_HEIGHT } from "../../constants";
import { Scrollbars } from "react-custom-scrollbars";
import {
  Button,
  Input,
  Row,
  Col,
  Checkbox,
  Pagination,
  TreeSelect,
  message,
  Empty
} from "antd";
const { Search } = Input;

const typeList = [
  {
    title: "全部",
    value: "0",
    key: "0",
  },
  {
    title: "启用",
    value: "1",
    key: "1",
  },
  {
    title: "禁用",
    value: "2",
    key: "2",
  },
];

export default class SpecialColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: 1, //当前页
      size: 10, //每页条数
      dataList: [], //数据源,
      listTotal: 0, //列表总数
      selectKey: "0", //栏目筛选
      columnList: [], //栏目列表
      typeKey: "0", //状态筛选
      typeList: [], //状态列表
      searchValue: null, //搜索文字
      allChoose: false, //全选
      visible: false,
      specialColumnListId: [], //置顶id
      despecialColumnListId: [], //删除id
      editClickId: [], //点击编辑id
      fileList: [],
    };
  }
  componentDidMount() {
    this.pageChange();
    this.getColumnLists();
  }

  // 新增专栏
  addST() {
    var url = "/cm-sites/pms/mediaFusion/specialTopicEdit.html";
    window.layer.open({
      title: "新增专题",
      type: 2,
      content: url,
      area: ["800px", "500px"],
      resize: true,
    });
  }

  // 获取删除id
  deleteSpecialColumnListId(specialColumnID) {
    let params = {
      id: specialColumnID,
    };
    deleteSpecialColumnListID(params, (res) => {
      if (res) {
        this.state.despecialColumnListId = res;
        // 直接更新页面
        this.pageChange();
      }
    });
  }
  // 点击删除
  delete = (id) => {
    this.deleteSpecialColumnListId(id);
  };
  // 获取置顶id
  getSpecialColumnListId(specialColumnID) {
    let params = {
      id: specialColumnID,
    };
    getSpecialColumnListID(params, (res) => {
      if (res) {
        message.success("修改成功");
        this.pageChange();
      } else {
        message.error("修改失败");
      }
    });
  }
  // 点击编辑
  getClickEditId(editId) {
    let params = {
      id: editId,
    };
    getEditId(params, (res) => {
      if (res) {
        this.state.editClickId = res;
        this.setState({});
      }
    });
  }
  // 编辑保存时
  getEditStore(obj) {
    let params = {
      createDate: obj.createDate,
      creator: "jtbj1",
      enabled: obj.enabled,
      id: obj.id,
      name: obj.name,
      shortName: obj.shortName,
      showPicture: obj.showPicture,
      storagePicture: obj.storagePicture,
      top: obj.top,
      updateBy: "jtbj1",
      updateDate: obj.updateDate,
    };
    getStoreData(params, (res) => {
      if (res) {
        message.success("保存成功");
        this.pageChange();
      } else {
        message.error("保存失败");
      }
    });
  }
  // 新增专栏
  getAddColumns(obj) {
    let params = {
      enabled: obj.enabled,
      name: obj.name,
      shortName: obj.shortName,
      showPicture: obj.showPicture,
      storagePicture: obj.storagePicture,
      top: obj.top,
    };
    getAddColumn(params, (res) => {
      if (res === true) {
        message.success("保存成功");
        this.pageChange();
      } else {
        message.error("保存失败");
      }
    });
  }
  // // 点击上传
  // clickUpLoads(){
  //   let params={
  //     file: (binary)
  //   }
  //   Actions.clickUpLoad(params,(res)=>{
  //     if(res){
  //       this.state.fileList=res;
  //       this.setState({})
  //     }
  //   })
  // }
  // 点父选全部子
  allChoose() {
    // 改变子组件选中
    if (this.state.allChoose) {
      this.state.dataList.forEach((item) => {
        item.checked = false;
      });
    } else {
      this.state.dataList.forEach((item) => {
        item.checked = true;
      });
    }
    // 改变父组件自己选中状态
    this.state.allChoose = !this.state.allChoose;
    // 更新
    this.setState({});
  }

  // 点子操作父
  itemClick(item, index) {
    // 把每条数据的显示状态给每条数据对应下标的显示状态
    this.state.dataList[index].checked = !item.checked;
    // 获取数据源的长度
    let numMax = this.state.dataList.length;
    // 初始选中的长度
    let num = 0;
    // 遍历数据源判断
    this.state.dataList.forEach((item) => {
      // 如果一个子未选中，则父不选中
      if (item.checked === false) {
        this.state.allChoose = false;
      } else {
        // 子长度加1
        num++;
      }
    });
    // 如果子长度等于数据源的长度，则父状态按钮显示
    if (numMax === num) {
      this.state.allChoose = true;
    }
    // 更新
    this.setState({});
  }
  // 获取栏目数据
  getColumnLists() {
    let params = {
      isBackchildren: true,
    };
    getColumnList(params, (res) => {
      if (res) {
        this.state.columnList = res;
      }
      this.getList(this.state.columnList);
      this.setState({
        columnList: this.state.columnList,
      });
    });
  }

  // 递归调用，初始化栏目数据
  getList(data) {
    data.forEach((item) => {
      item.title = item.treeName;
      item.value = item.id;
      item.key = item.id;
      if (item.children && item.children.length > 0) {
        this.getList(item.children); //取嵌套数据
      }
    });
  }
  // 新增专栏
  AddSpecialColumn = () => {
    // this.refs.AddSpecialColumn.showModal();
    this.addST();
  };
  // 重置
  reset = () => {
    this.setState({
      start: 1,
      size: 10
    })
    this.state.typeKey = "0"
    this.state.searchValue = null
    this.pageChange()
  }
  // 渲染
  render() {
    let newSecondSelectColor =
      this.props.config && this.props.config.getValueByKey
        ? this.props.config.getValueByKey("newSecondSelectColor", "#1E9FFF")
        : "#1E9FFF";
    let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
    const { columnList } = this.state;
    return (
      <div
        style={{
          padding: "10px 20px",
          backgroundColor: "#fff",
          margin: "10px 10px",
        }}
      >
        {/* 头部 */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* 左侧 */}
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <span style={{ margin: "0px 15px" }}>筛选</span>
                <span style={{ marginRight: "15px" }}>|</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <span style={{ marginLeft: "25px", marginRight: "15px" }}>
                  状态
                </span>
              </div>
              <div style={{ width: "200px" }}>
                <TreeSelect
                  style={{ width: "200px" }}
                  value={this.state.typeKey}
                  treeData={typeList}
                  onChange={(value) => {
                    // console.log(value);
                    this.state.typeKey = value;
                    this.state.page = 1;
                    this.state.size = 10;
                    this.setState({});
                    this.pageChange();
                  }}
                />
              </div>
            </div>
            <div
              style={{
                marginLeft: "25px",
              }}
            >
              <Button
                style={{
                  color: newSecondSelectColor,
                  border: "1px " + newSecondSelectColor + " solid",
                }}
                onClick={this.AddSpecialColumn}
              >
                新增专栏
              </Button>
            </div>
            {/* 新增专栏 */}
            <AddSpecialColumn
              ref="AddSpecialColumn"
              getAddColumns={(obj) => this.getAddColumns(obj)}
              dataList={this.state.dataList}
            />
          </div>
          {/* 右侧 */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "200px", marginLeft: "20px" }}>
              <Search
                placeholder="请输入搜索内容"
                onSearch={(value) => this.onSearch(value)}
                value={this.state.searchValue}
                onChange={(e) => {
                  this.setState({
                    searchValue: e.target.value,
                  });
                }}
                style={{ width: 200 }}
              />
            </div>
            <div
              style={{ marginLeft: "20px", }}>
              <Button
                onClick={this.reset}
                type="primary"
                style={{
                  background: newSecondSelectColor, borderColor: newSecondSelectColor
                }}>重置</Button>
            </div>
          </div>
        </div>
        {/* 列表 */}
        <div
          style={{ border: "1px solid #ccc", padding: "5px", marginTop: "7px" }}
        >
          <Row justify="start">
            {/* 全选 */}
            <Col span={11}>
              <Checkbox
                style={{ marginRight: "20px" }}
                onClick={() => {
                  this.allChoose();
                }}
                checked={this.state.allChoose}
              />
              专栏全称
            </Col>
            <Col span={3} style={{ textAlign: "center" }}>
              状态
            </Col>
            <Col span={3} style={{ textAlign: "center" }}>
              创建时间
            </Col>
            <Col span={3} style={{ textAlign: "center" }}>
              最新修改时间
            </Col>
            <Col span={4} style={{ textAlign: "center" }}>
              操作
            </Col>
          </Row>
        </div>
        {/* 处理滚动条的方法以及自适应 */}
        <div style={{ height: height - 145, background: "white" }}>
          <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
            {/* 循环组件 */}
            {
              this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
            }
            {this.state.dataList &&
              this.state.dataList.map((item, index) => {
                return (
                  <SpecialColumnList
                    ref="set"
                    newSecondSelectColor={newSecondSelectColor}
                    columnList={this.state.columnList}
                    key={index}
                    {...item}
                    name={item.name}
                    enabled={item.enabled}
                    top={item.top} //置顶
                    shortName={item.shortName}
                    desc={item.describe}
                    storagePicture={item.storagePicture}
                    showPicture={item.showPicture}
                    status={item.status}
                    id={item.id}
                    createDate={
                      item.createDate && item.createDate.time
                        ? utils.formatDate(item.createDate.time) //转化时间
                        : ""
                    }
                    updateDate={
                      item.updateDate && item.updateDate.time
                        ? utils.formatDate(item.updateDate.time) //转化时间
                        : ""
                    }
                    delete={(id) => this.delete(id)} //删除
                    checked={item.checked} //拿到每条数据的checked属性
                    ItemClick={() => {
                      this.itemClick(item, index); //传一个操作每条数据的方法
                    }}
                    getClickEditId={(editId) => this.getClickEditId(editId)}
                    getEditStore={(obj) => this.getEditStore(obj)}
                    getSpecialColumnListId={() =>
                      this.getSpecialColumnListId(item.id)
                    }
                  />
                );
              })}
          </Scrollbars>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Pagination
            hideOnSinglePage={true}
            showQuickJumper
            current={this.state.start}
            pageSize={this.state.size}
            total={this.state.listTotal}
            showTotal={(total) => `共 ${total} 条`}
            showSizeChanger
            onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
            onShowSizeChange={(page, pageSize) => {
              this.onChange(page, pageSize); //每页条数改变回调
            }}
          />
        </div>
      </div>
    );
  }
  // 页面改变时回调
  onChange(page, pageSize) {
    // 放入变量中
    this.state.start = page;
    this.state.size = pageSize;
    // 每次改变页码时
    this.pageChange();
  }
  pageChange() {
    //先取出变量
    let params = {
      start: this.state.start,
      size: this.state.size,
      type: 2,
      source: 0,
      sort: "updateDate",
    };
    // 给body添加columnId属性
    if (this.state.selectKey) {
      params.columnId = this.state.selectKey;
    }
    if (this.state.typeKey) {
      params.status = this.state.typeKey;
    }
    if (this.state.searchValue) {
      params.queryStr = this.state.searchValue;
    }
    getSpecialColumnList(params, (res) => {
      let dataList = [];
      let listTotal = 0; //列表总数
      if (res && res.data) {
        dataList = res.data;
        // 遍历数据源给每条数据添加checked属性
        dataList.forEach((item) => {
          item.checked = false;
        });
        listTotal = res.count;
      }
      this.setState({
        dataList: dataList,
        listTotal: listTotal,
      });
    });
    // 分页时清空全选按钮
    this.setState({
      allChoose: false,
    });
  }

  //搜索
  onSearch(value) {
    this.state.searchValue = value;
    this.state.start = 1;
    this.state.size = 10;
    this.pageChange();
  }
}
